import Head from 'next/head';
import React from 'react';

const OG_SITE_NAME = 'og:site_name';
const TWITTER_SITE_NAME = 'twitter:site';

type SiteNameHeadProps = {
  siteName?: string;
  twitter?: string;
};

/**
 * SiteNameHead Component to set the site name meta tags.
 * @param {string} siteName - The site name
 * @param {string} twitter - The twitter handle for support
 */
// TODO: remember to check Twitter once we get to prod
function SiteNameHead({ siteName = process.env.NEXT_PUBLIC_BRAND, twitter }: SiteNameHeadProps) {
  if (!siteName && !twitter) return null;
  return (
    <Head>
      {siteName ? <meta property={OG_SITE_NAME} key={OG_SITE_NAME} content={siteName} /> : null}
      {twitter ? (
        <meta property={TWITTER_SITE_NAME} key={TWITTER_SITE_NAME} content={twitter} />
      ) : null}
    </Head>
  );
}

export default React.memo(SiteNameHead);
